import React from 'react';
import { Box, Text } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons-react';

import type { Request } from '../../../codegen/graphql';
import { TableCellDetailPopover } from './TableCellDetailPopover';
import { THIN_BORDER_CELL_DETAIL_TRIGGER_CLASSNAME } from './cellDetailSurfaceClasses';
import { CellDetailTriggerChevron } from './cellDetailTriggerChevron';
import { FuturePricesQueryPanel } from '../future-prices/FuturePricesQueryPanel';

type Props = {
    request: Request;
};

export function FuturePricesTableCell({ request }: Props) {
    const productId = request.productId ?? '';

    if (!request.hasFuturePrice || !productId) {
        return null;
    }

    const trigger = (
        <div className="flex h-full min-h-0 w-full items-center justify-between gap-2">
            <div className="flex min-w-0 items-center gap-2">
                <IconCalendarEvent
                    size={18}
                    stroke={1.5}
                    className="shrink-0 text-primary"
                />
                <Text
                    size="sm"
                    fw={600}
                    className="whitespace-nowrap text-gray-900"
                >
                    View future prices
                </Text>
            </div>
            <CellDetailTriggerChevron />
        </div>
    );

    return (
        <Box className="flex w-full justify-center">
            <TableCellDetailPopover
                title="Future Prices"
                trigger={trigger}
                triggerClassName={THIN_BORDER_CELL_DETAIL_TRIGGER_CLASSNAME}
            >
                {({ opened }) => (
                    <FuturePricesQueryPanel
                        productId={productId}
                        skip={!opened}
                        maxItems={1}
                    />
                )}
            </TableCellDetailPopover>
        </Box>
    );
}
